import LangSwitch from './lang-switch';
export default LangSwitch;
